import React, { useEffect, useState } from 'react';
import "./Category.css";
import { NavLink } from 'react-router-dom';
import { Icon } from 'react-icons-kit';
import { arrowUp } from 'react-icons-kit/feather/arrowUp';
import { trash } from 'react-icons-kit/feather/trash';
import { eye } from 'react-icons-kit/feather/eye';
import { arrowUpRight } from 'react-icons-kit/feather/arrowUpRight';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { DeleteRole, GetRolePage } from '../apiconfig/authService';

function Role(props) {
    const navigate = useNavigate();
    const { decodedToken, isExpired } = useJwt(localStorage.getItem('accessToken'));
    if (isExpired)
        navigate('/');

    const message = props.message;

    const [recordIdToDelete, setRecordIdToDelete] = useState('');
    const [refetchData, setRefetchData] = useState(false);
    const [roleData, setRoleData] = useState([]);
    const [totalRoles, setTotalRoles] = useState(0);

    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    console.log(roleData, totalRoles, pageCount);


    const handlePerPageRecordsChange = (e) => {
        setItemsPerPage(e.target.value);
        setPageCount(1);
    };

    const formatUTCDate = (utcDateString) => {
        const date = new Date(utcDateString);
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZoneName: 'short',
        };
        const readableFormat = date.toLocaleString(undefined, options);
        return readableFormat.substring(0, readableFormat.length - 9);
    };

    useEffect(() => {
        (
            async () => {
                try {
                    const response = await GetRolePage(page, itemsPerPage, search, localStorage.getItem('accessToken'));
                    setRoleData(response.data.items);
                    setPageCount(Math.ceil(response.data.pagination.pageCount));
                    setTotalRoles(response.data.pagination.count);
                } catch (error) {
                    console.log(error);
                }
            }
        )();
    }, [page, itemsPerPage, refetchData]);

    const handleDeleteRoleClick = async (roleid) => {
        try {
            await DeleteRole(roleid, localStorage.getItem('accessToken'));
            setRefetchData(!refetchData);
        } catch (error) {
            console.log(error);
        }
    };

    const handleViewRoleClick = (roleid) => {
        navigate(`/viewRole/${roleid}`);
    };
    const handleEditRoleClick = (roleid) => {
        navigate(`/editRole/${roleid}`);
    };

    const handlePrevious = () => {
        setPage((p) => {
            if (p === 1) return p;
            return p - 1;
        });
    };
    const handleNext = () => {
        setPage((p) => {
            if (p === pageCount) return p;
            return p + 1;
        });
    };

    const handleSearchBoxSubmit = (event) => {
        event.preventDefault();
        setPage(1);
        setRefetchData(!refetchData)
    };

    return (
        <div className="dashboard-content">
            {/* <div className="mobileOption d-flex align-items-center justify-content-between">
                <div  className="buyMore"><img className="img-fluid" src={logoImg} alt=""/></div>
                <button className="btn btn-primary offCanvasToggler" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling"><Icon className="menu" icon={menu} size={25}/></button>
            </div> */}
            <Sidebar />
            <div className="body-cart tab-content dasContent p-4 bg-white rounded">
                <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
                    <h1 className="heading h4 mb-0 fw-bold">Role Management<br /><small className="text-primary h6 fw-bold">Total counts {totalRoles}</small></h1>
                    <div className="d-inline-flex gap-2">
                        <NavLink to="/addRole" className="btn btn-primary addSeller">Add Role</NavLink>
                    </div>
                </div>
                <div className="collapse mb-4" id="filter">
                    <div className="card card-body">
                        <form className="filterForm" action="/">
                            <div className="row">
                                <div className="col-lg-12 mb-2">
                                    <h4 className="text-primary h6 fw-bold">Filter Things</h4>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-4 mb-2">
                                    <div className="form-floating">
                                        <select className="form-select" id="floatBilling" aria-label="Billing">
                                            <option defaultValue>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                        <label htmlFor="floatBilling">Billing</label>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-2">
                                    <div className="form-floating">
                                        <select className="form-select" id="floatStatus" aria-label="Status">
                                            <option defaultValue>Select</option>
                                            <option value="1">One</option>
                                            <option value="2">Two</option>
                                            <option value="3">Three</option>
                                        </select>
                                        <label htmlFor="floatStatus">Status</label>
                                    </div>
                                </div>
                                <div className="col-lg-4 mb-2">
                                    <button type="submit" className="btn btn-primary btn-lg save-btn text-uppercase w-100">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="searchList row">
                    <div className="displayRecord d-flex align-items-center col-lg-6 mb-2">
                        <span className="h6 mb-0">Display Records</span>
                        <select className="form-select" value={itemsPerPage} onChange={handlePerPageRecordsChange}>
                            <option defaultValue="5">5</option>
                            <option value="10">10</option>
                            <option value="15">15</option>
                            <option value="20">20</option>
                        </select>
                    </div>
                    <div className="searchForm d-flex justify-content-end col-lg-6 mb-2">
                        <form className="sForm" onSubmit={handleSearchBoxSubmit}>
                            <input type="text" onChange={(event) => { setSearch(event.target.value) }} className="form-control form-control-lg w-100" id="s" placeholder="Search" />
                        </form>
                    </div>
                </div>
                {message && <div className="alert alert-primary" role="alert">{message}</div>}
                <div className="table-responsive">
                    <table className="table table-borderless table-hover">
                        <thead>
                            <tr>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '50px' }} scope="col" width="45" align="center">
                                    <div className="selectAll">
                                        <input className="form-check-input" type="checkbox" />
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col" width="80">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">SR.</span>
                                        <button className="filtBtn idFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Role ID</span>
                                        <button className="filtBtn fNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Role Name</span>
                                        <button className="filtBtn lNameFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Role Profile</span>
                                        <button className="filtBtn statusFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '300px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Role Parents</span>
                                        <button className="filtBtn emailFilter"><Icon className="arrowUp" icon={arrowUp} size={18} /></button>
                                    </div>
                                </th>
                                <th style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', minWidth: '150px' }} scope="col">
                                    <div className="tableHeadItems position-relative">
                                        <span className="text-ellipsis">Action</span>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="table-group-divider">
                            {
                                roleData?.map((item, index) => (
                                    <tr key={item._id}>
                                        <td><input className="form-check-input" type="checkbox" /></td>
                                        <td>{index + 1}</td>
                                        <td>{item.roleid}</td>
                                        <td>{item.rolename}</td>
                                        <td>{item.profileInfo.profilename}</td>
                                        <td>{item.parentroles.join(":")}</td>
                                        <td>
                                            <div className="d-grid gap-2 d-md-block">
                                                <button type="button" onClick={() => { handleViewRoleClick(item.roleid) }} className="actBtn viewBtn">
                                                    <Icon className="eye" icon={eye} size={18} />
                                                    <span className="toolTip">Preview</span>
                                                </button>
                                                <button type="button" onClick={() => { handleEditRoleClick(item.roleid) }} className="actBtn editBtn">
                                                    <Icon className="arrowUpRight" icon={arrowUpRight} size={18} />
                                                    <span className="toolTip">Edit</span>
                                                </button> &nbsp;
                                                <button onClick={() => { setRecordIdToDelete(item.roleid) }} data-bs-toggle="modal" data-bs-target="#exampleModal" type="button" className="actBtn delBtn">
                                                    <Icon className="trash" icon={trash} size={18} />
                                                    <span className="toolTip">Delete</span>
                                                </button> &nbsp;
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
                <div className="resultList pt-3 border-top">
                    <div className="row">
                        <div className="displayRecord col-lg-6 mb-2">
                            {/* <span className="h6 mb-0">Showing 1 of 5 of 3 entries</span> */}
                        </div>
                        <div className="searchForm d-flex justify-content-end col-lg-6 mb-2">
                            <nav aria-label="...">
                                <ul className="pagination pagination-sm">
                                    {/* <li className="page-item active" aria-current="page"> */}
                                    {/* <span className="page-link">Previous</span>
                                    </li> */}
                                    <li className="page-item"><button className="page-link" disabled={page === 1} onClick={handlePrevious}>Previous</button></li>
                                    <li className="page-item"><button className="page-link" disabled={page === pageCount} onClick={handleNext}>Next</button></li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="exampleModal" tabIndex="10" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body text-center p-5">
                                <h1 className="modal-title display-6 mb-4" id="exampleModalLabel">Procced with delete?</h1>
                                <button type="button" className="btn btn-danger me-2" data-bs-dismiss="modal">No</button>
                                <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => { handleDeleteRoleClick(recordIdToDelete) }}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Role;
